
import {AbstractUI} from "./AbstractUI";
import bidello,{component} from "bidello";
import {stateManager, States} from "../services/StateManager";
import {Ajax} from "../services/Ajax";
import {viewport} from "../threejs/bidello";

export class ContentDrawer extends component(AbstractUI){

    init(){

        this.lastUrl = "";

    }

    close (){

        this.lastUrl = "";
        this.domElement.classList.remove('open');
        if (viewport.isVertical){

            console.log (stateManager.addBodyState('with-main-header'),'is reverticalcslkndl');

        }

    }

    open (){

        this.lastUrl = "";
        this.domElement.classList.add('open');
        if (viewport.isVertical){

            console.log (stateManager.removeBodyState('with-main-header'),'remove body state');

        }

    }

    onStateChange(state){

        console.log(state)
        if (state.url !== "" && state.url !== "#")this.loadAjaxContent(state.url);
        if (state.state == States.contentDrawer.CLOSE_STATE)this.close();

    }

    loadAjaxContent(url) {

        if (!url) return;
        if (url == this.lastUrl) return;
        this.lastUrl = url;
        document.querySelector('#content-drawer .inner').innerHTML = "";

        this.open();
        Ajax.Get(url, {"HTTP_X_AJAX_LOADER": 1}).then((result) => {
            const state = {
                url: url,

            };
            history.pushState(state, "hello", url);
            document.querySelector('#content-drawer .inner').innerHTML = "";
            document.querySelector('#content-drawer .inner').insertAdjacentHTML("beforeend", result);

        })
    }



}